module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.94/css/toolsmenu.css"